import React from "react";

import Richtext from "../Richtext";

import type { PdfSinglePageProps } from "./types.d";

// Ported from views/pdf/single-page.html. Inline styles are kept because the PDF
// engine relies on them (Roboto import does not work in generated PDFs).
export default function PdfSinglePage(props: Readonly<PdfSinglePageProps>) {
  const {
    title,
    imageUrl,
    imageCaption,
    intro,
    bodyHtml,
    showMargin,
    start,
    slutt,
    singleDay,
    sted,
    tag,
    legalOwnerAndContributors,
    children
  } = props;

  const contributors = legalOwnerAndContributors?.contributors ?? [];

  return (
    <div
      className={`l-container print-pdf${showMargin ? " l-mb-5" : ""}`}
      style={{ fontFamily: "Arial, Helvetica, sans-serif", fontSize: "13px", lineHeight: 1.4 }}
    >
      <div className="row l-mt-1">
        <div className="col-md-8 col-xs-12 col-md-offset-2">
          <div className="b-article-intro">
            <div className="b-article-intro__text b-article-intro__text--with-image">
              {title && (
                <h1 style={{ fontSize: "34px", lineHeight: 1.2, margin: "10px 0 30px" }}>{title}</h1>
              )}
            </div>
            {imageUrl && (
              <div>
                <img
                  className="b-article-intro__image"
                  style={{ width: "100%" }}
                  src={imageUrl}
                  alt={imageCaption}
                  aria-labelledby={imageCaption}
                />
                {imageCaption && (
                  <p className="b-article-intro__image-text" id={imageCaption}>{imageCaption}</p>
                )}
              </div>
            )}
            {intro && (
              <p className="b-article-intro__intro">{intro}</p>
            )}
          </div>

          <ul className="b-meta-list">
            {start && slutt && (
              <li className="b-meta-list__item">
                <span className="b-icon-with-text">
                  {!singleDay
                    ? (
                      <span>{`Dato: ${start.day}. ${start.month}-${slutt.day}. ${slutt.month}`}</span>
                    )
                    : (
                      <span>{`Dato: ${start.day}. ${start.month}`}</span>
                    )}
                </span>
              </li>
            )}
            {singleDay && start && slutt && (
              <li className="b-meta-list__item">
                <span className="b-icon-with-text__text-wrapper">
                  <span className="b-icon-with-text__text">
                    <div>{`Tid: ${start.hour}:${start.minute}-${slutt.hour}:${slutt.minute}`}</div>
                  </span>
                </span>
              </li>
            )}
            {sted && (
              <li className="b-meta-list__item">{`Sted: ${sted}`}</li>
            )}
          </ul>
          {tag && (
            <div className="b-tags">
              <div className="b-tags__item">{tag}</div>
            </div>
          )}
        </div>
      </div>

      <article
        className="col-md-8 col-xs-12 col-md-offset-2 t-body-text"
        id="article"
        style={{ fontSize: "13px", lineHeight: 1.4 }}
      >
        {bodyHtml ? <Richtext text={bodyHtml} /> : children}

        {contributors.length > 0 && (
          <div className="l-mt-4">
            <hr className="b-hr b-hr--grey-light" />
            <div className="l-mt-1 b-secondary-logos">
              <div className="b-secondary-logos__logolist">
                {contributors.map((publisher) => (
                  <img key={publisher.name} src={publisher.logoUrl} alt={publisher.name} />
                ))}
              </div>
              <div className="b-secondary-logos__text">
                <p>{legalOwnerAndContributors?.contributorsRole}</p>
              </div>
            </div>
          </div>
        )}
      </article>
    </div>
  );
}
